<template>
  <v-menu bottom left offset-y rounded min-width="355">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab color="blue" icon>
        <v-icon x-large color="white">
          mdi-exit-run
        </v-icon>
      </v-btn>
    </template>
    <v-card class="pb-2">
      <v-card-text>
        <v-row justify="center">
          <v-col cols="auto">
            <v-icon x-large>
              mdi-account-circle
            </v-icon>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            cols="auto"
            v-text="user.nome"
            class="font-weight-bold py-0 text-uppercase"
          />
        </v-row>

        <v-row justify="center" v-if="atribuicao">
          <v-col
            cols="auto"
            class="py-0 text-uppercase"
            v-text="atribuicao.instituicao.nomeCompleto"
          />
        </v-row>

        <v-row justify="center" v-if="atribuicao">
          <v-col
            cols="auto"
            class="py-0 text-uppercase"
            v-text="atribuicao.grupo.nome"
          />
        </v-row>

        <v-row v-if="atribuicoes.length > 1">
          <v-col cols="12" class="px-0">
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list dense title="Atribuições">
              <v-list-item
                v-for="atribuicao in atribuicoes"
                :key="atribuicao.id"
                link
                @click.stop="handleAtribuicao(atribuicao)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="atribuicao.instituicao.nomeCompleto.toUpperCase()"
                  />
                  <v-list-item-subtitle>
                    {{ atribuicao.grupo.nome.toUpperCase() }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="px-0">
            <v-divider />
          </v-col>
        </v-row>

        <v-row justify="end">
          <v-col cols="12">
            <CPTbtn icon="mdi-exit-to-app" label="SAIR" @click="logout" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <CPTLoadingDialog
      :showDialog="dialog"
      dialogMessage="Alterando Unidade de Ensino..."
    />
  </v-menu>
</template>

<script>
import CPTbtn from "@/components/Btn";
import CPTLoadingDialog from "@/components/LoadingDialog";

import {
  getAtribuicoes,
  getAtribuicaoAtiva,
  setAtribuicaoAtiva,
  getUser,
  isAdmin,
  isAuthenticated,
  isGestor,
  logout
} from "@/plugins/security";

export default {
  data: () => ({
    user: getUser(),
    fav: true,
    menu: false,
    message: false,
    hints: true,

    atribuicoes: [],
    atribuicao: null,
    dialog: false
  }),

  components: {
    CPTbtn,
    CPTLoadingDialog
  },

  mounted() {
    this.atribuicao = getAtribuicoes().find(
      ({ id }) => id === getAtribuicaoAtiva()?.id
    );
    this.atribuicoes = getAtribuicoes().filter(
      ({ id }) => id !== getAtribuicaoAtiva()?.id
    );
  },

  methods: {
    isAdmin,
    isAuthenticated,
    isGestor,
    logout,
    getAtribuicaoAtiva,
    setAtribuicaoAtiva,

    handleAtribuicao(atribuicao) {
      this.dialog = true;
      setAtribuicaoAtiva(atribuicao);
    }
  }
};
</script>

<style scoped>
.profile-reveal {
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: #4445;
  width: 100%;
  height: 100%;
}
</style>
